"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const row_1 = __importDefault(require("./row"));
const label_1 = __importDefault(require("../label"));
const text_input_1 = __importDefault(require("../inputs/text-input"));
const use_form_1 = __importStar(require("../../form/use-form"));
const read_only_1 = __importDefault(require("../read-only"));
/**
 * Get the full name as a string excluding falsy values to avoid extra spaces
 */
const getFullName = ({ prefix, first, middle, last, suffix }) => {
    return [prefix, first, middle, last, suffix].filter(Boolean).join(' ');
};
/**
 * Generate a field JSX element and pass in required props
 */
function generateField({ config, isRequiredMarker, isNotRequiredMarker, hiddenLabel }) {
    if (!config || !config.isVisible)
        return null;
    return (react_1.default.createElement(react_1.Fragment, null,
        config.label ? (react_1.default.createElement(label_1.default, { isRequired: config.isRequired, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, style: { marginLeft: '0' } }, config.label)) : null,
        react_1.default.createElement(text_input_1.default, Object.assign({ label: hiddenLabel }, config))));
}
// [prefix, first, middle, last, suffix]
const FLEX_GROW_SIZES = [1, 2, 2, 2, 1];
/**
 * Renders a row of connected inputs for the name object
 *
 *         +-----------------------------------------+
 *  label  | prefix | first | middle | last | suffix |
 *         +-----------------------------------------+
 */
const NameInputRow = ({ path }) => {
    const [{ config: { width, label, subFields, isReadOnly, breakpoints, getInitialValue } }] = (0, use_form_1.default)(path);
    const { context: { isRequiredMarker, isNotRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    const subFieldValues = getInitialValue();
    if (isReadOnly)
        return (react_1.default.createElement(row_1.default, { label: label, width: width },
            react_1.default.createElement(read_only_1.default, { msg: getFullName({
                    prefix: subFieldValues[subFields.prefix.path],
                    first: subFieldValues[subFields.first.path],
                    middle: subFieldValues[subFields.middle.path],
                    last: subFieldValues[subFields.last.path],
                    suffix: subFieldValues[subFields.suffix.path]
                }) })));
    return (react_1.default.createElement(row_1.default, { flexGrowSizes: FLEX_GROW_SIZES, label: label, isRequired: subFields.first && subFields.first.isRequired, width: width, breakpoints: breakpoints },
        generateField({
            hiddenLabel: 'Prefix',
            config: subFields['prefix'],
            isRequiredMarker: isRequiredMarker,
            isNotRequiredMarker: isNotRequiredMarker
        }),
        generateField({
            hiddenLabel: 'First name',
            config: subFields['first'],
            isRequiredMarker: isRequiredMarker,
            isNotRequiredMarker: isNotRequiredMarker
        }),
        generateField({
            hiddenLabel: 'Middle name',
            config: subFields['middle'],
            isRequiredMarker: isRequiredMarker,
            isNotRequiredMarker: isNotRequiredMarker
        }),
        generateField({
            hiddenLabel: 'Last name',
            config: subFields['last'],
            isRequiredMarker: isRequiredMarker,
            isNotRequiredMarker: isNotRequiredMarker
        }),
        generateField({
            hiddenLabel: 'Suffix',
            config: subFields['suffix'],
            isRequiredMarker: isRequiredMarker,
            isNotRequiredMarker: isNotRequiredMarker
        })));
};
NameInputRow.propTypes = {
    path: prop_types_1.default.string
};
exports.defaultConfig = {
    prefix: { placeholder: 'Prefix', autoComplete: 'honorific-prefix' },
    first: { placeholder: 'First Name', autoComplete: 'given-name' },
    middle: { placeholder: 'Middle Name', autoComplete: 'additional-name' },
    last: { placeholder: 'Last Name', autoComplete: 'family-name' },
    suffix: { placeholder: 'Suffix', autoComplete: 'honorific-suffix' }
};
exports.default = NameInputRow;
//# sourceMappingURL=name-input-row.js.map